module.exports = __webpack_public_path__ + "img/POINT_OF_SALE.ca943e22.svg";